import Button from '@material-ui/core/Button';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import InputAdornment from '@material-ui/core/InputAdornment';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import React, { Component } from "react";
import { Glyphicon, Table } from 'react-bootstrap';
import XLSX from 'xlsx';
import EnhancedTableHead from '../components/EnhancedTableHead';
import { RowCountOptions } from "../Config";
import "../css/store.css";
import { ProductService } from "../Services/ProductService";
import { UserService } from "../Services/UserService";
import { toInt, HtmlTooltip, getTimeInIST, format_fancy_notime, format_display_DDMMYYYY, formatNumber } from '../Utils';
import { ROLES } from '../Roles';
import { Checkbox, FormControlLabel, Tooltip, Fade, CircularProgress, LinearProgress, Grid } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { RouteService } from '../Services/RouteService';
import EnhancedTableToolbar from '../components/EnhancedTableToolbar';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import EditIcon from '@material-ui/icons/Edit';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import { Color, STATES } from '../Constants';
import ItemSelection from '../components/ItemSelection';
import moment from 'moment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const styles = theme => ({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom: '20px',
    },
    selected: {
        "&$selected": {
            backgroundColor: "#739f26",
            color: 'white'
        },
        color: 'black'
    },
    formControlAutoComplete: {
        zIndex: 3,
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(0),
        },
    }
});

class Store extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            originalData: [],
            current_rows: [],
            numItemsPerPage: 10,
            currentPageNumber: 0,
            totalItems: 0,
            totalPages: 0,
            filter: '',
            new_store: { store_name: "", min_amount: 0, min_qty_check: "1", allowed_credit_limit: "-1", allowed_max_credit_due: "-1", multiple_deliveries: "0", generate_invoice: "1", sorting_enabled: "0", name: "", email: "", mobile_no: "", state: "", flat: "", gst_no: "", agent_id: "", po_no: "", location: "", contract: new Map() },
            agentList: [],
            store_contracts: new Map(),
            selectedAgent: null,
            master_contract: [],
            contract_rows: [],
            show: false,
            showContractDialog: false,
            contract_dialog_details: [],
            columns: [
                { id: 'store_name', numeric: false, disablePadding: false, label: 'Store', sortable: true },
                { id: 'name', numeric: false, disablePadding: false, label: 'Manager', sortable: true },
                { id: 'email', numeric: false, disablePadding: false, label: 'Email', sortable: true },
                { id: 'mobile_no', numeric: false, disablePadding: false, label: 'Contact', sortable: true },
                { id: 'flat', numeric: false, disablePadding: false, label: 'Address', sortable: true },
                { id: 'state', numeric: false, disablePadding: false, label: 'State', sortable: true },
                { id: 'gst_no', numeric: false, disablePadding: false, label: 'GST No', sortable: true },
                { id: 'min_amount', numeric: true, disablePadding: false, label: 'Minimum sales Amount', sortable: true },
                { id: 'allowed_credit_limit', numeric: true, disablePadding: false, label: 'Allowed Credit Limit', sortable: true },
                { id: 'allowed_max_credit_due', numeric: true, disablePadding: false, label: 'Allowed Max Credit Due(days)', sortable: true },
                { id: 'route_name', numeric: false, disablePadding: false, label: 'Route', sortable: false },
                { id: 'agent_name', numeric: false, disablePadding: false, label: 'Agent', sortable: false },
                { id: 'created_date', numeric: false, disablePadding: false, label: 'Added on', sortable: false },
                { id: 'min_qty_check', align: 'center', numeric: false, disablePadding: false, label: 'Minimum Quantity Check', sortable: true },
                { id: 'multiple_deliveries', align: 'center', numeric: false, disablePadding: false, label: 'Multiple sameday billing', sortable: true },
                { id: 'generate_invoice', numeric: false, disablePadding: false, label: 'Invoice Generation', sortable: false },
                { id: 'sorting_enabled', numeric: false, disablePadding: false, label: 'Sequenced Delivery', sortable: false },
                { id: 'po_no', numeric: false, disablePadding: false, label: 'Current PO No', sortable: false },
                { id: 'contract_details', numeric: false, disablePadding: false, label: 'Contract Details', sortable: false },
                { id: 'actions', numeric: false, disablePadding: false, label: '', sortable: false },
            ],
            order: 'asc',
            orderBy: 'store_name',
            message: '',
            status_filter: '0,1,2',
            fetching: false,
            selectedRoute: {},
            loading: false
        }

        this.handleSelect = this.handleSelect.bind(this);
        this.clearSearch = this.clearSearch.bind(this);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCommissionChange = this.handleCommissionChange.bind(this);
        this.newStore = this.newStore.bind(this);
        this.createModifyStore = this.createModifyStore.bind(this);
        this.removeStore = this.removeStore.bind(this);

        this.showContracts = this.showContracts.bind(this);
        this.handleCloseContractDialog = this.handleCloseContractDialog.bind(this);
        this.handleShowContractDialog = this.handleShowContractDialog.bind(this);

        // Export
        this.export = this.export.bind(this);

        //Sort
        this.sortBy = this.sortBy.bind(this);
    }

    componentDidMount() {
        UserService.getTotalCount("STORE", '', this.state.status_filter)
            .then((data) => {
                this.props.setTitle(`Stores - ${data.count}`);
            })
            .catch(error => {
                console.log(error);
            });
        this.setState({ fetching: true });
        this.fetchCount();
        this.fetchAgentList();
        this.fetchProducList();
        this.fetchMasterRoutes();
    }

    fetchMasterRoutes = () => {
        RouteService.getRouteList()
            .then((data) => {
                this.setState({
                    masterRoutes: data.routes
                });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    fetchCount = () => {
        this.props.isLoading(true);
        UserService.getTotalCount("STORE", this.state.filter, this.state.status_filter)
            .then((data) => {
                this.setState({
                    totalItems: toInt(data.count),
                    totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
                });
                this.setState({ fetching: false });
                this.props.isLoading(false);
                this.fetchData(0, this.state.numItemsPerPage, this.state.filter);
            })
            .catch(error => {
                console.log(error);
                this.setState({ fetching: false });
                this.props.isLoading(false);
            });
    }

    handleSelection = (event, status) => {
        if (status !== null) {
            this.setState({ status_filter: status }, () => this.fetchCount());
        }
    }

    fetchProducList() {
        ProductService.getProductList()
            .then((data) => {
                let m = [];
                data.products.filter(p => p.status !== -1).forEach(element => {
                    m.push({ product_id: element.id, product_name: element.name, commission: undefined, min_qty: 0 });
                });
                this.setState({ master_contract: m });
            })
            .catch((error) => {
                console.log("Error while fetching product list");
            });
    }

    fetchAgentList() {
        UserService.getAgentList()
            .then((data) => {
                this.setState({ agentList: data.users });
                this.setState({ fetching: false });
            })
            .catch(error => {
                console.log(error);
                this.setState({ fetching: false });
            });
    }

    toggleStatus = (e, store) => {
        e.preventDefault();
        this.props.showConfirmDialog(`${store.status === "0" ? "Activate" : "Deactivate"} store ${store.store_name}? ${store.status === "0" ? "" : " All future products scheduled will have Qty marked as 0."}`, undefined, () => {
            UserService.toggleAgentStatus(store.id, { 'user-id': this.props.user.id, 'user-name': this.props.user.name })
                .then((data) => {
                    const status = data.status === "0" ? "Deactivated" : "Activated";
                    this.props.showSnackBar(`${status} store ${store.store_name}`, 'info');
                    this.fetchCount();
                    this.props.closeConfirmDialog();
                })
                .catch(error => console.log(error));
        });
    }

    togglePause = (e, store) => {
        e.preventDefault();
        if (store.status === "2") {
            this.props.showConfirmDialog(`Resume service for store ${store.store_name}?`, `Resume Service`, () => {
                UserService.togglePauseState(store.id, '', 1, { 'user-id': this.props.user.id, 'user-name': this.props.user.name })
                    .then((data) => {
                        const message = "Store now Active";
                        this.props.showSnackBar(message, 'info');
                        this.fetchCount();
                        this.props.closeConfirmDialog();
                    })
                    .catch(error => console.log(error));
            });
        } else {
            this.props.showConfirmDialog(`Pause service for store ${store.store_name}?`, `Pause Service`, (reason) => {
                UserService.togglePauseState(store.id, reason, 2, { 'user-id': this.props.user.id, 'user-name': this.props.user.name })
                    .then((data) => {
                        const message = "Store now Paused";
                        this.props.showSnackBar(message, 'info');
                        this.fetchCount();
                        this.props.closeConfirmDialog();
                    })
                    .catch(error => console.log(error));
            }, "Cancel", "Confirm", true, 'Reason', ``);
        }
    }

    removeStore(e, store) {
        e.preventDefault();
        this.props.showConfirmDialog(`Confirm removal of ${store.store_name} Store?`, undefined, () => {
            UserService.removeStore(store.id)
                .then((data) => {
                    this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                    this.props.closeConfirmDialog();
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage: event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if (this.state.currentPageNumber > page) {
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(start, numberItems, filter = '') {
        this.setState({ fetching: true });
        this.props.isLoading(true);
        let rows = [];
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        UserService.getStoreList(start, numberItems, filter, sort, direction, this.state.status_filter)
            .then((data) => {
                this.setState({ data: data.users, originalData: data.users });
                if (data.users) {
                    data.users.forEach((user) => {
                        this.fetchStoreContracts(user.id);
                        rows.push(<UserDetails key={user.id} user={user} showContracts={this.showContracts} edit={this.newStore} remove={this.removeStore} toggleStatus={this.toggleStatus} togglePause={this.togglePause} roles={this.props.user.roles} />);
                    });
                    this.setState({
                        current_rows: rows
                    });
                }

                this.setState({ fetching: false });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.setState({ fetching: false });
                this.props.isLoading(false);
            });
    }

    fetchStoreContracts(store_id) {
        UserService.getStoreContractList(store_id)
            .then((data) => {
                if (data.contracts.length > 0) {
                    let store_contracts = this.state.store_contracts;
                    let contractMap = new Map();
                    data.contracts.forEach((contract) => {
                        contractMap.set(contract.product_id, { commission: parseFloat(contract.commission), min_qty: toInt(contract.min_qty) });
                    });
                    store_contracts.set(store_id, contractMap);
                    this.setState({ store_contracts: store_contracts });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.new_store;
        change[e.target.name] = e.target.value;
        this.setState({ new_store: change });
    }

    handleChangeState = (state) => {
        if (state && state.code) {
            let change = this.state.new_store;
            change.state = state.code;
            this.setState({ new_store: change });
        }
    }

    handleChangeCheckBox = name => e => {
        if (e) {
            e.preventDefault();
        }
        let change = this.state.new_store;
        change[name] = e.target.checked ? "1" : "0";
        this.setState({ new_store: change });
    }

    handleCommissionChange(type, e) {
        let change = this.state.new_store;
        let key = e.target.name;
        let value = -1;
        if (e.target.value.length > 0) {
            value = type === 'commission' ? parseFloat(e.target.value) : toInt(e.target.value);
        }

        if (change.contract.has(key)) {
            let commission = change.contract.get(key);
            commission[type] = value;
        } else {
            let commission = {};
            commission[type] = value;
            change.contract.set(key, commission);
        }

        this.setState({ new_store: change });
    }

    newStore(e, store) {
        if (store) {
            //Add previous contract values to state and populate the form
            this.setState({ selectedAgent: this.state.agentList.filter((agent) => agent.id === store.agent_id)[0], selectedRoute: this.state.masterRoutes.filter((r) => r.id === store.route_id)[0], new_store: { id: store.id, generate_invoice: store.generate_invoice, sorting_enabled: store.sorting_enabled, min_qty_check: store.min_qty_check, allowed_credit_limit: store.allowed_credit_limit, allowed_max_credit_due: store.allowed_max_credit_due, multiple_deliveries: store.multiple_deliveries, min_amount: store.min_amount, store_name: store.store_name, email: store.email, name: store.name, mobile_no: store.mobile_no, flat: store.flat, state: store.state, gst_no: store.gst_no, agent_id: store.agent_id, po_no: store.po_no, location: store.location, route_id: store.route_id, route_name: store.route_name, contract: this.state.store_contracts.get(store.id) ? this.state.store_contracts.get(store.id) : new Map() } });
        }
        let rows = [];
        this.state.master_contract.forEach((element, index) => {
            let sContract = store && store.id ? this.state.store_contracts.get(store.id) : undefined;
            rows.push(
                <tr key={index}>
                    <td style={{ verticalAlign: "middle", width: '50%' }}>{element.product_name}</td>
                    <td style={{ verticalAlign: "right", width: '25%' }}>
                        <TextField
                            label="Commission"
                            placeholder="Commission"
                            name={element.product_id}
                            defaultValue={store && store.id && sContract && sContract.get(element.product_id) ? sContract.get(element.product_id).commission : element.commission}
                            className={this.props.classes.textField}
                            margin="dense"
                            variant="outlined"
                            onChange={(e) => this.handleCommissionChange('commission', e)}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                inputProps: { min: 0, max: 100, step: 0.1 }
                            }} />
                    </td>
                    <td style={{ verticalAlign: "right", width: '25%' }}>
                        <TextField
                            label="Minimum Quantity at Shelf"
                            placeholder="Minimum Quantity at Shelf"
                            name={element.product_id}
                            defaultValue={store && store.id && sContract && sContract.get(element.product_id) ? sContract.get(element.product_id).min_qty : element.min_qty}
                            className={this.props.classes.textField}
                            margin="dense"
                            variant="outlined"
                            onChange={(e) => this.handleCommissionChange('min_qty', e)}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">NOS</InputAdornment>,
                                inputProps: { min: 0, max: 1000, step: 1 }
                            }} />
                    </td>
                </tr>
            );
        });
        this.setState({ contract_rows: rows });

        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_store: { store_name: "", min_amount: 0, min_qty_check: "1", allowed_credit_limit: "-1", allowed_max_credit_due: "-1", multiple_deliveries: "0", generate_invoice: "1", sorting_enabled: "0", name: "", email: "", mobile_no: "", flat: "", state: "", gst_no: "", agent_id: "", po_no: "", location: "", contract: new Map() }
        });
    }

    handleShowContractDialog() {
        this.setState({ showContractDialog: true });
    }

    handleCloseContractDialog() {
        this.setState({ showContractDialog: false });
        this.setState({ contract_dialog_details: [] });
    }

    handleShow() {
        this.setState({ show: true });
    }

    showContracts(e, user) {
        e.preventDefault();
        let rows = [];
        if (this.state.store_contracts.get(user.id)) {
            this.state.store_contracts.get(user.id).forEach((value, key, map) => {
                let product_name = this.state.master_contract.filter(m => m.product_id === key)[0].product_name;
                if (value.commission >= 0) {
                    rows.push(
                        <tr key={key}>
                            <td>{product_name ? product_name : '-'}</td>
                            <td>
                                {value.commission}
                            </td>
                            <td>
                                {value.min_qty}
                            </td>
                        </tr>
                    );
                }
            });
            this.setState({ contract_dialog_details: rows });
            this.handleShowContractDialog();
        } else {
            this.props.showSnackBar('No Contracts found', 'info');
        }
    }

    confirmSave = () => {
        let new_store = this.state.new_store;
        if (!this.props.loading) {
            this.setState({ fetching: true });
            let contracts = [];
            new_store.contract.forEach((value, key, map) => {
                if (value.commission >= 0) {
                    contracts.push({ "product_id": key, "commission": value.commission, min_qty: value.min_qty });
                } else {
                    contracts.push({ "product_id": key, "commission": -1, min_qty: value.min_qty });
                }
            });

            new_store.contract = contracts;
            this.setState({ loading: true });
            UserService.createStore({ 'user-id': this.props.user.id, 'user-name': this.props.user.name }, new_store)
                .then((data) => {
                    this.setState({ fetching: false });
                    this.handleClose();
                    this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, this.state.filter);
                    this.setState({ loading: false });
                    if (data.sorting_flag_changed) {
                        this.props.showConfirmDialog('Now Sequence is enabled for Store. Please go to Store > Store Delivery Sequence Planner to order the store delivery', undefined, () => {
                            this.props.history.push(`/store/delivery/sequence/planner?agent=${new_store.agent_id}`);
                        }, 'Later', 'Lets Do it');
                    }
                })
                .catch(error => {
                    this.props.showSnackBar(`Something went wrong. Please try again later.`, 'error');
                    this.setState({ fetching: false });
                    this.setState({ loading: false });
                });
        }
    }

    createModifyStore(e) {
        e.preventDefault();
        let new_store = this.state.new_store;
        let minQtyError = false;
        new_store.contract.forEach((value, key, map) => {
            let min = value.min_qty || 0;
            if (value.commission >= 0 && min < 1) {
                minQtyError = true;
            }
        });
        if (minQtyError) {
            this.props.showConfirmDialog("Minimum quantity should be atleast 1. Please check and try again.", undefined, undefined);
        } else if (new_store.name && new_store.name.trim().length > 0 && new_store.store_name
            && new_store.store_name.trim().length > 0 && new_store.email && new_store.email.trim().length > 0
            && new_store.mobile_no && new_store.mobile_no.trim().length > 0 && new_store.flat
            && new_store.state && this.state.selectedAgent) {
            new_store.agent_id = this.state.selectedAgent.id;
            if (this.state.selectedRoute) {
                new_store.route_id = this.state.selectedRoute.id;
            }
            this.setState({ new_store: new_store }, () => this.props.showConfirmDialog("Save Store", "Confirm", () => {
                this.props.closeConfirmDialog();
                this.confirmSave();
            }));
        } else {
            this.props.showConfirmDialog("Please fill in all the Mandatory details and continue", undefined, undefined);
        }
    }

    clearSearch(e) {
        this.refs.inputText.value = "";
        this.setState({ filter: '' });
        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
    }

    filterCriteria = (e) => {
        e.preventDefault();
        let searchText = "";
        if (e) {
            e.preventDefault();
            searchText = e.target.value || "";
        } else {
            searchText = this.state.searchText;
        }
        this.setState({ filter: searchText }, () => this.fetchCount());
    }

    handleSelect(eventKey, e) {
        if (eventKey === 'prev') {
            if ((this.state.currentPageNumber) > 0) {
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if (eventKey === 'next') {
            if ((this.state.currentPageNumber) < this.state.totalPages) {
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage) {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    export(e) {
        if (e) {
            e.preventDefault();
        }
        this.props.isLoading(true);
        UserService.getStoreListWithContracts(0, this.state.totalItems, true, this.state.status_filter)
            .then((data) => {
                let products = this.state.master_contract.map((p) => p.product_name);
                if (data.users) {
                    let title = ["Sl. No", "Store", "Manager Name", "Email", "Contact No", "Address", "State Code", "GST No", "Route", "Delivery Agent", "Added on", "Allowed Credit Limit", "Allowed Max Credit Due(days)", "Contract Details"];
                    let title_sheet2 = ["Sl. No", "Store", "Route", "Delivery Agent", "Min Qty Details"];
                    title.push.apply(title, products);
                    title_sheet2.push.apply(title_sheet2, products);
                    let exportStoreData = [title];
                    let exportStoreMinQtyData = [title_sheet2];
                    this.setState({ fetching: true });
                    data.users.forEach((user, index) => {
                        let storeArray = [index + 1, user.store_name, user.name, user.email, user.mobile_no, user.flat, user.state, user.gst_no, user.route_name ? user.route_name : "-", user.delivery_agent_name ? user.delivery_agent_name : "-", user.created_date ? moment(user.created_date).format(format_display_DDMMYYYY) : "-", (user.allowed_credit_limit && parseFloat(user.allowed_credit_limit) !== -1 ? user.allowed_credit_limit : "-"), (user.allowed_max_credit_due && user.allowed_max_credit_due !== '-1' ? user.allowed_max_credit_due : "-"), ''];
                        let storeArray_sheet2 = [index + 1, user.store_name, user.route_name ? user.route_name : "-", user.delivery_agent_name ? user.delivery_agent_name : "-", ''];
                        let contracts = this.state.master_contract.map((p) => {
                            let cont = user.contracts.filter((c) => c.product_id === p.product_id);
                            if (cont.length > 0) {
                                return cont[0].commission;
                            } else {
                                return "0";
                            }
                        });
                        let minQty = this.state.master_contract.map((p) => {
                            let cont = user.contracts.filter((c) => c.product_id === p.product_id);
                            if (cont.length > 0) {
                                return toInt(cont[0].min_qty);
                            } else {
                                return 0;
                            }
                        });
                        storeArray.push.apply(storeArray, contracts);
                        storeArray_sheet2.push.apply(storeArray_sheet2, minQty);
                        exportStoreData.push(storeArray);
                        exportStoreMinQtyData.push(storeArray_sheet2);
                    });
                    if (exportStoreData) {
                        const wb = XLSX.utils.book_new();
                        const wsAll = XLSX.utils.aoa_to_sheet(exportStoreData);
                        const wsAll1 = XLSX.utils.aoa_to_sheet(exportStoreMinQtyData);
                        XLSX.utils.book_append_sheet(wb, wsAll, 'Stores - Contract details');
                        XLSX.utils.book_append_sheet(wb, wsAll1, 'Stores - Min Qty');
                        XLSX.writeFile(wb, "Store List.xlsx");
                        this.setState({ fetching: false });
                    }
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ fetching: false });
            })
            .finally(() => this.props.isLoading(false));
    }

    render() {
        let { status_filter, message, fetching } = this.state;
        return (
            <div className="Home" style={{ marginTop: 32 }}>
                <div className="">
                    <p style={{ color: "red", paddingLeft: "20px" }}>{message}</p>
                    {!message &&
                        <Paper className={this.props.classes.root} style={{ width: "100%", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px", marginBottom: 100 }}>
                            <EnhancedTableToolbar
                                title={
                                    <div>
                                        <Typography variant="caption" gutterBottom>Filter By:</Typography>
                                        <ToggleButtonGroup
                                            size="small"
                                            value={status_filter}
                                            exclusive
                                            onChange={this.handleSelection}
                                            aria-label="text alignment" style={{ paddingLeft: 10 }}>
                                            <ToggleButton value='0,1,2' aria-label="stores all" classes={{ selected: this.props.classes.selected }}>
                                                All
                                            </ToggleButton>
                                            <ToggleButton value='1' aria-label="stores active" classes={{ selected: this.props.classes.selected }}>
                                                Active
                                            </ToggleButton>
                                            <ToggleButton value='0' aria-label="stores deactivated" classes={{ selected: this.props.classes.selected }}>
                                                Deactivated
                                            </ToggleButton>
                                            <ToggleButton value='2' aria-label="stores paused" classes={{ selected: this.props.classes.selected }}>
                                                Paused
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                }
                                exportReport={this.export}
                                onSearchTextChange={this.filterCriteria}
                                searchText={this.state.filter}
                                loading={this.props.loading}
                            />
                            <Table striped condensed hover responsive>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows={this.state.columns} />
                                <TableBody>
                                    {!fetching && this.state.current_rows}
                                </TableBody>
                            </Table>
                            <Fade
                                in={fetching}
                                style={{
                                    transitionDelay: fetching ? "10ms" : "0ms"
                                }}
                                unmountOnExit
                            >
                                <CircularProgress style={{ marginTop: 20 }} />
                            </Fade>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </Paper>
                    }
                </div>
                <DialogMUI
                    fullWidth={true}
                    maxWidth="lg"
                    disableBackdropClick
                    disableEscapeKeyDown
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                    <DialogTitle id="alert-dialog-title">{this.state.new_store.store_name ? "Store Details" : "Create Store"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <Grid container spacing={1} alignItems='center' justify='flex-start'>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        id="store_name"
                                        label="Store Name"
                                        placeholder="Store Name"
                                        name="store_name"
                                        defaultValue={this.state.new_store.store_name}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        id="name"
                                        label="Manager Name"
                                        placeholder="Manager Name"
                                        name="name"
                                        defaultValue={this.state.new_store.name}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <ItemSelection
                                        label='Choose a Route'
                                        size={"small"}
                                        required
                                        value={this.state.masterRoutes &&
                                            this.state.masterRoutes.find(r => r.id === this.state.new_store.route_id)}
                                        optionLabel='name'
                                        formControlStyle={this.props.classes.formControlAutoComplete}
                                        autoCompleteStyle={{ zIndex: 500, marginRight: 0 }}
                                        options={this.state.masterRoutes}
                                        selected={(route) => this.setState({ selectedRoute: route })} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="gst_no"
                                        label="GST No"
                                        placeholder="GST No"
                                        name="gst_no"
                                        defaultValue={this.state.new_store.gst_no}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Minimum Sales amount"
                                        placeholder="Minimum Sales amount"
                                        name="min_amount"
                                        defaultValue={this.state.new_store.min_amount}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        fullWidth
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">INR</InputAdornment>,
                                            inputProps: { min: 0, step: 1 }
                                        }} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="allowed_credit_limit"
                                        label="Allowed Credit Limit"
                                        placeholder="Allowed Credit Limit"
                                        name="allowed_credit_limit"
                                        defaultValue={this.state.new_store.allowed_credit_limit}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        type='number'
                                        fullWidth
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">INR</InputAdornment>,
                                            inputProps: { min: 0, step: 1 }
                                        }}
                                        helperText="Set -1 to disable this check" />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="allowed_max_credit_due"
                                        label="Allowed Max Credit Due"
                                        placeholder="Allowed Max Credit Due"
                                        name="allowed_max_credit_due"
                                        defaultValue={this.state.new_store.allowed_max_credit_due}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        fullWidth
                                        type='number'
                                        helperText="Set -1 to disable this check"
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">Days</InputAdornment>,
                                            inputProps: { min: 0, step: 1 }
                                        }} />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.new_store.generate_invoice === "1"}
                                                onChange={this.handleChangeCheckBox('generate_invoice')}
                                                color="primary"
                                            />
                                        }
                                        label="Generate Invoices and Credit Notes"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.new_store.sorting_enabled === "1"}
                                                onChange={this.handleChangeCheckBox('sorting_enabled')}
                                                color="primary"
                                            />
                                        }
                                        label="Enable Sequenced Delivery"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.new_store.min_qty_check === "1"}
                                                onChange={this.handleChangeCheckBox('min_qty_check')}
                                                color="primary"
                                            />
                                        }
                                        label="Min Quantity check"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.new_store.multiple_deliveries === "1"}
                                                onChange={this.handleChangeCheckBox('multiple_deliveries')}
                                                color="primary"
                                            />
                                        }
                                        label="Multiple sameday billing"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="mobile_no"
                                        label="Contact Number"
                                        placeholder="Contact Number"
                                        name="mobile_no"
                                        defaultValue={this.state.new_store.mobile_no}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="email"
                                        label="Email"
                                        placeholder="Email"
                                        name="email"
                                        type="email"
                                        defaultValue={this.state.new_store.email}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="flat"
                                        label="Address"
                                        placeholder="Address"
                                        name="flat"
                                        defaultValue={this.state.new_store.flat}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        helperText="Store Address"
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="location"
                                        label="Latitude, Longitude"
                                        placeholder="Latitude, Longitude"
                                        name="location"
                                        defaultValue={this.state.new_store.location}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        helperText="Enter location in the format Latitude, Longitude. eg: 13.12312,78.909090"
                                        fullWidth />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <ItemSelection
                                        label='State'
                                        size={"small"}
                                        required
                                        clearable={true}
                                        value={(this.state.new_store.state && STATES.find(s => s.code === this.state.new_store.state)) || null}
                                        optionLabel='name'
                                        formControlStyle={this.props.classes.formControlAutoComplete}
                                        autoCompleteStyle={{ zIndex: 500, marginRight: 0 }}
                                        options={STATES}
                                        selected={this.handleChangeState} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <ItemSelection
                                        label='HappyMilk Incharge'
                                        size={"small"}
                                        required
                                        clearable={true}
                                        value={this.state.agentList.find((agent) => agent.id === this.state.new_store.agent_id)}
                                        optionLabel='name'
                                        formControlStyle={this.props.classes.formControlAutoComplete}
                                        autoCompleteStyle={{ zIndex: 500, marginRight: 0 }}
                                        options={STATES}
                                        selected={(selected) => this.setState({ "selectedAgent": selected })} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        id="po_no"
                                        label="PO no"
                                        placeholder="PO no"
                                        name="po_no"
                                        defaultValue={this.state.new_store.po_no}
                                        className={this.props.classes.textField}
                                        margin="dense"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        fullWidth />
                                </Grid>
                            </Grid>
                            <Typography variant="subtitle1" id="modal-title">
                                Contract Details
                            </Typography>
                            <Divider variant='middle' />
                            <Table striped>
                                <tbody>
                                    {this.state.contract_rows}
                                </tbody>
                            </Table>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Close
                        </Button>
                        <Button onClick={this.createModifyStore} color="primary" autoFocus disabled={this.state.loading}>
                            Save
                        </Button>
                    </DialogActions>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                </DialogMUI>
                <DialogMUI
                    disableEscapeKeyDown
                    open={this.state.showContractDialog}
                    onClose={this.handleCloseContractDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogTitle id="alert-dialog-title">{this.state.showContractDialog ? "Contract Details" : ""}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <Divider />
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Commission</th>
                                        <th>Min Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.contract_dialog_details}
                                </tbody>
                            </Table>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseContractDialog} color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </DialogMUI>
                {this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN) &&
                    <Fab variant="extended" onClick={this.newStore} color="primary" aria-label="Add" className={this.props.classes.fab} style={{ position: 'fixed', top: '87%', left: '86.5%' }}>
                        <AddIcon />
                        Add Store
                    </Fab>
                }
            </div>
        );
    }

    getValidationStateName() {
        if (this.state.new_store.name) {
            const length = this.state.new_store.name.length;
            if (length >= 3) return 'success';
            else return 'error';
        }
        return null;
    }
}

class UserDetails extends Component {

    render() {
        const user = this.props.user;
        const roles = this.props.roles;
        const isAdmin = roles.includes(ROLES.ACCOUNTS_ADMIN) || roles.includes(ROLES.ADMIN);
        const isStoreAdmin = roles.includes(ROLES.STORE_MANAGEMENT) || roles.includes(ROLES.ADMIN);
        //   const format = 'YYYY-MM-DD HH:mm:SS';
        //   const time = moment(location.time, format);
        return (
            <Tooltip title={user.status === "0" ? "The store is deactive" : user.status === "2" ? "Paused" : ""}>
                <tr className={user.status === "0" ? "danger" : ""} style={user.status === "2" ? { backgroundColor: Color.yellow } : {}}>
                    <td>
                        <div style={{ width: 300, textAlign: 'justify' }}>
                            <Typography align="left" variant="body2">{user.store_name}</Typography>
                        </div>
                    </td>
                    <td align="left">{user.name}</td>
                    <td align="left">{user.email}</td>
                    <td>{user.mobile_no}</td>
                    <td align="justify">
                        <div style={{ width: 300 }}>
                            {user.flat}
                        </div>
                    </td>
                    <td align="justify">
                        {STATES.find(s => s.code === user.state).name}
                    </td>
                    <td>{user.gst_no ? user.gst_no : '-'}</td>
                    <td align="right">{user.min_amount}</td>
                    <td align="right">{parseFloat(user.allowed_credit_limit || -1) !== -1 ? formatNumber(user.allowed_credit_limit) : 'NA'}</td>
                    <td align="right">{parseFloat(user.allowed_max_credit_due || -1) !== -1 ? user.allowed_max_credit_due : 'NA'}</td>
                    <td>
                        <div style={{ width: 150 }}>
                            {user.route_name ? user.route_name : '-'}
                        </div>
                    </td>
                    <td>{user.agent_name}</td>
                    <td>{user.created_date ? getTimeInIST(user.created_date).format(format_display_DDMMYYYY) : '-'}</td>
                    <td align="center">
                        <HtmlTooltip arrow title={user.min_qty_check === "1" ? "Enabled" : "Disabled"}>
                            <CheckCircleIcon color={user.min_qty_check === "1" ? "primary" : "secondary"} />
                        </HtmlTooltip>
                    </td>
                    <td align="center">
                        <HtmlTooltip arrow title={user.multiple_deliveries === "1" ? "Enabled" : "Disabled"}>
                            <CheckCircleIcon color={user.multiple_deliveries === "1" ? "primary" : "secondary"} />
                        </HtmlTooltip>
                    </td>
                    <td>
                        <HtmlTooltip arrow title={user.generate_invoice === "1" ? "Enabled" : "Disabled"}>
                            <CheckCircleIcon color={user.generate_invoice === "1" ? "primary" : "secondary"} />
                        </HtmlTooltip>
                    </td>
                    <td>
                        <HtmlTooltip arrow title={user.sorting_enabled === "1" ? "Enabled" : "Disabled"}>
                            <CheckCircleIcon color={user.sorting_enabled === "1" ? "primary" : "secondary"} />
                        </HtmlTooltip>
                    </td>
                    <td>{user.po_no}</td>
                    <td style={{ cursor: 'pointer' }}>
                        <HtmlTooltip arrow title="View Store Contracts">
                            <ListAltIcon style={{ fontSize: 22 }} onClick={(e) => this.props.showContracts(e, user)} />
                        </HtmlTooltip>
                    </td>
                    <td>
                        {isAdmin &&
                            <HtmlTooltip arrow title="Edit">
                                <EditIcon style={{ marginRight: 10, cursor: 'pointer', fontSize: 22 }} onClick={(e) => this.props.edit(e, user)} />
                            </HtmlTooltip>
                        }
                        {
                            false &&
                            <HtmlTooltip arrow title="Remove Store">
                                <Glyphicon style={{ marginRight: 10, cursor: 'pointer', fontSize: 22 }} glyph="trash" onClick={(e) => this.props.remove(e, user)} />
                            </HtmlTooltip>
                        }
                        {isStoreAdmin && user.status !== '2' &&
                            <HtmlTooltip arrow title="Activate/Deactivate">
                                <PowerSettingsNewIcon style={{ marginRight: 10, cursor: 'pointer', fontSize: 22 }} onClick={(e) => this.props.toggleStatus(e, user)} />
                            </HtmlTooltip>
                        }
                        {isStoreAdmin && (
                            user.status === '2'
                                ?
                                <HtmlTooltip arrow title="Resume Service">
                                    <PlayCircleOutlineIcon style={{ marginRight: 10, cursor: 'pointer', fontSize: 22 }} onClick={(e) => this.props.togglePause(e, user)} />
                                </HtmlTooltip>
                                :
                                <HtmlTooltip arrow title="Pause Service">
                                    <PauseCircleOutlineIcon style={{ marginRight: 10, cursor: 'pointer', fontSize: 22 }} onClick={(e) => this.props.togglePause(e, user)} />
                                </HtmlTooltip>
                        )}
                        {
                            user.status === '2' && (
                                <div style={{ width: 200 }}>
                                    <Typography variant="caption" component="div"><b>Reason:{` `}</b>{user.pause_reason}</Typography>
                                    <Typography variant="caption" color="textSecondary" component="div"><b>Paused on{` `}</b>{getTimeInIST(user.pause_datetime).format(format_fancy_notime)}</Typography>
                                </div>
                            )}
                    </td>
                </tr>
            </Tooltip>
        );
    }
}

export default withStyles(styles)(Store);